
import { Component } from 'react';
import './Help.css';

class Help extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false
    }
    this.closeModal = this.closeModal.bind(this)
  }
  linkToBlank(href) {
    window.open(href)
  }
  openModal() {
    this.setState({ showModal: true })
  }
  closeModal() {
    this.setState({ showModal: false })
  }
  render() {
    const docs = [
      { title: '小程序', url: 'https://docs.qq.com/space/DUk5UWVNsSnNnbERH?tab=collaborator' },
      { title: '上机流程', url: 'https://docs.qq.com/space/DUmtPYmNseFFXUGN2' },
      { title: '后台相关', url: 'https://docs.qq.com/space/DUmZ2a2h1dmdOcHZK' },
      { title: '管理系统操作指南', url: 'https://docs.qq.com/space/DUkFVSFFPZWJxTHNN' },
      { title: '常见问题', url: 'https://docs.qq.com/space/DUkxjaXpnRGxsZ0Fs' }
    ]
    return (
        <div className="help" id='help'>
        <div className='help-wrap'>
            <div className='help-center' onClick={() => this.openModal()}>
              <span className='help-icon'></span>
              <p className='help-text'>帮助中心</p>
            </div>
            <div className='help-api' onClick={() => this.linkToBlank('http://api.mblyun.com/doc.html')}>
              <span className='api-icon'></span>
              <p className='help-text'>API文档</p>
            </div>
          </div>
          {this.state.showModal && (
            <div className='help-modal-overlay' onClick={this.closeModal}>
              <div className='help-modal' onClick={e => e.stopPropagation()}>
                <div className='help-modal-header'>
                  <span className='help-modal-title'>帮助中心</span>
                  <span className='help-modal-close' onClick={this.closeModal}>&times;</span>
                </div>
                <div className='help-modal-body'>
                  {docs.map((doc, index) => (
                    <div className='help-modal-item' key={index} onClick={() => this.linkToBlank(doc.url)}>
                      <span className='help-modal-doc-icon'>📄</span>
                      <span className='help-modal-doc-title'>{doc.title}</span>
                      <span className='help-modal-doc-arrow'>→</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      );
  }
}

export default Help;
